export default function IntroModal({ onStart }) {

  return (
    <div className="intro-modal">

      <div className="intro-content">

        <h2>Здравей Ани!</h2>

        <h2>
          Имам малка игра за теб.
          Намери всички двойки,
          за да разкриеш посланието.
        </h2>

        <button className="button" onClick={onStart}>
          Старт
        </button>

      </div>

    </div>
  );

}